'use client';

import { useEffect, useState } from 'react';
import { PropertyListing } from '@/app/actions/serverActions';
import { PropertyCard } from './PropertyCard/PropertyCard';
import { exploreProperties } from '@/app/actions/Properties/actions';

export default function FeaturedProperties() {
  const [properties, setProperties] = useState<PropertyListing[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadProperties = async () => {
      try {
        const { properties: data } = await exploreProperties({
          page: 1,
          pageSize: 6,
          isFeatured: true,
          sort: 'updated',
        });
        setProperties(data);
      } catch (error) {
        console.error('Error loading featured properties:', error);
      } finally {
        setIsLoading(false);
      }
    };

    loadProperties();
  }, []);

  if (isLoading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 gap-6">
        {Array.from({ length: 6 }).map((_, index) => (
          <div key={index} className="animate-pulse bg-gray-100 rounded-lg gap-4 p-4 flex flex-col">
            <div className="bg-gray-200 h-48 rounded-lg mb-4"></div>
            <div className="h-4 bg-gray-200 rounded w-3/4 mb-2"></div>
            <div className="h-4 bg-gray-200 rounded w-1/2"></div>
            <div className="h-4 bg-gray-200 rounded w-1/2"></div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 gap-8">
      {properties.map((property) => (
        <PropertyCard key={property.id} property={property} featured={false} />
      ))}
    </div>
  );
}
